<nav #nav class="menubar">
  <div *ngIf="isMobile" (click)="toggleMenu()" class="flex gap-2 w-full cursor-pointer align-items-center">
    <app-button icon="pi pi-bars" styleClass="p-button-rounded p-button-text" />
    <ng-container *ngIf="selectedItem">
      <ng-container *ngIf="selectedItemTemplate; else defaultSelectedItem">
        <ng-container *ngTemplateOutlet="selectedItemTemplate; context: { $implicit: selectedItem }"></ng-container>
      </ng-container>
      <ng-template #defaultSelectedItem>
        <h4 class="m-0">{{ selectedItem.label }}</h4>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="endTemplate">
      <ng-container *ngTemplateOutlet="endTemplate"></ng-container>
    </ng-container>
  </div>

  <ul #menu class="desktop-menu" [class.visual-hidden]="isMobile">
    <li *ngFor="let item of items; let index = index">
      <ng-container *ngTemplateOutlet="menuItem; context: { item: item, index: index }"></ng-container>
    </li>
  </ul>

  <ul class="mobile-menu" *ngIf="isMobile && isOpen">
    <li *ngFor="let item of items; let index = index">
      <ng-container *ngTemplateOutlet="menuItem; context: { item: item, index: index }"></ng-container>
    </li>
  </ul>
</nav>

<!-- Shared menu item template -->
<ng-template #menuItem let-item="item" let-index="index">
  <ng-container *ngIf="itemTemplate; else defaultItem">
    <a (click)="selectItem({ originalEvent: $event, item, index }); closeMenu()">
      <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
    </a>
  </ng-container>
  <ng-template #defaultItem>
    <a (click)="selectItem({ originalEvent: $event, item, index }); closeMenu()">
      {{ item.label }}
    </a>
  </ng-template>
</ng-template>
